import { DataSource } from '@angular/cdk/collections';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { MatPaginator, MatSort } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { NoticiasDatabase } from './noticiasDatabase';
import { Noticia } from '../../../../models/noticias/noticia';

export class NoticiasDataSource extends DataSource<any> {
    _filterChange = new BehaviorSubject('');
    filteredData: Noticia[] = [];
    renderedData: Noticia[] = [];
    dataLength = 0;
    _publicado = false;
    _enPortada = false;
    _tipo = '';

    get filter(): string {
        return this._filterChange.value;
    }

    set filter(filter: string) {
        this._filterChange.next(filter);
    }

    constructor(
        private _subjectDatabase: NoticiasDatabase,
        private _paginator: MatPaginator,
        private _sort: MatSort) {
        super();
        // Reset to the first page when the store changes the filter.
        this._filterChange.subscribe(() => this._paginator.pageIndex = 0);
    }

    /** Connect function called by the table to retrieve one stream containing the data to render. */
    connect(): Observable<Noticia[]> {
        // Listen for any changes in the base data, sorting, filtering, or pagination
        const displayDataChanges = [
            this._subjectDatabase.dataChange,
            this._sort.sortChange,
            this._filterChange,
            this._paginator.page
        ];

        return Observable.merge(...displayDataChanges).map(() => {
            // Filter data
            this.filteredData = this._subjectDatabase.data.slice().filter((item: Noticia) => {
                const searchStr = (item.Titulo).toLowerCase();
                const enPortada = item.EnPortada;
                const publicado = item.Publicado;
                const tipo = item.TipoNoticiaId;
                return (searchStr.indexOf(this.filter.toLowerCase()) !== -1) 
                        && (enPortada || enPortada == this._enPortada )
                        && (publicado || publicado == this._publicado )
                        && (this._tipo == '' || tipo == this._tipo );
            });

            // Sort filtered data
            const sortedData = this.sortData(this.filteredData.slice());

            // Grab the page's slice of the filtered sorted data.
            const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
            this.renderedData = sortedData.splice(startIndex, this._paginator.pageSize);
            this.dataLength = this._subjectDatabase.data.length;
            return this.renderedData;
        });
    }

    disconnect() {
    }

    /** Returns a sorted copy of the database data. */
    sortData(data: Noticia[]): Noticia[] {
        if (!this._sort.active || this._sort.direction === '') {
            return data;
        }
        return data.sort((a, b) => {
            let propertyA: number | string = '';
            let propertyB: number | string = '';
            switch (this._sort.active) {
                case 'Name':
                    [propertyA, propertyB] = [a.Titulo, b.Titulo];
                    break;
            }

            const valueA = isNaN(+propertyA) ? propertyA : +propertyA;
            const valueB = isNaN(+propertyB) ? propertyB : +propertyB;

            return (valueA < valueB ? -1 : 1) * (this._sort.direction === 'asc' ? 1 : -1);
        });
    }

    filterPublicado(publicado) {
        this._publicado = publicado;
        this._filterChange.next(this.filter);
    }

    filterEnPortada(enPortada) {
        this._enPortada = enPortada;
        this._filterChange.next(this.filter);
    }

    filterTipo(tipo) {
        this._tipo = tipo;
        this._filterChange.next(this.filter);
    }

}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/noticias/noticiasDataSource.ts